import type { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import type { PropsWithStyles } from '../types';

export const Container: FC<PropsWithChildren<PropsWithStyles>> = ({
  children,
  className,
  ...props
}) => (
  <div
    className={twMerge(
      'pointer-events-none [&_*]:pointer-events-auto z-[102] inline-flex flex-col gap-y-12 mr-16! mb-16!',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export const Layout: FC<PropsWithChildren<PropsWithStyles>> = ({
  children,
  className,
  ...props
}) => (
  <div
    className={twMerge(
      '!mx-auto max-w-[600px] fixed bottom-0 left-0 right-0 z-[101] flex justify-end pointer-events-none',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export const FloatingButtonGroup = {
  Layout,
  Container,
};
